import { useContext } from 'react';

import { SignInContext, USER_GROUPS } from '@modules/users';

const useCanUseAiEdit = () => {
  const { organization, user } = useContext(SignInContext);

  return (
    organization.featureSettings.aiEdit?.enabled === true &&
    user.hasAiLicense &&
    user.license === 'FULL' &&
    user.groups.includes(USER_GROUPS.AUTHOR)
  );
};

export default useCanUseAiEdit;
